import { render } from "./BrowsersChart.vue?vue&type=template&id=19429122&scoped=true"
import script from "./BrowsersChart.vue?vue&type=script&lang=js"
export * from "./BrowsersChart.vue?vue&type=script&lang=js"

import "./BrowsersChart.vue?vue&type=style&index=0&id=19429122&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19429122"]])

export default __exports__